import type {
  Condition,
  Configuration,
  ExportComplianceReportRequest,
} from '@repo/api-gw-sdk';
import { ComplianceApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/compliance/';

export const compliance = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const complianceApi = new ComplianceApi(config);

  return {
    // Failing resources are paginated server-side: the backend evaluates posture,
    // computes the full failing-group breakdowns, applies the optional group filter,
    // then returns just the requested page. The console never fetches the whole set.
    useFailingResources: (
      filter: Condition | undefined,
      enabled: boolean,
      page: number,
      pageSize: number,
      failingControlId: string,
      failingGroupBy?: string,
      failingGroupValue?: string
    ) =>
      httpClient.execute(
        complianceApi.listComplianceResources.bind(complianceApi),
        enabled ? baseUrl : null,
        'failing-resources',
        currentProjectId,
        page,
        pageSize,
        failingControlId,
        // The gateway rejects empty query params ("empty value is not allowed"),
        // so send undefined (omit the param) rather than an empty string.
        failingGroupBy || undefined,
        failingGroupValue || undefined,
        { filter }
      ),
    useSummary: (filter?: Condition, enabled = true) =>
      httpClient.execute(
        complianceApi.getComplianceSummary.bind(complianceApi),
        enabled ? baseUrl : null,
        'summary',
        currentProjectId,
        undefined,
        { filter }
      ),
    useControlTrends: (days = 90, filter?: Condition, enabled = true) =>
      httpClient.execute(
        complianceApi.getComplianceControlTrends.bind(complianceApi),
        enabled ? baseUrl : null,
        'control-trends',
        currentProjectId,
        days,
        { filter }
      ),
    exportReport: (body: ExportComplianceReportRequest) =>
      complianceApi.exportComplianceReport(currentProjectId, body),
  };
};
